import PropTypes from 'prop-types';
// form
import moment from 'moment';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFDatePicker.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFDatePicker({ name, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (

        <DatePicker
          value={field.value ? moment(field.value) : null}
          onChange={(newValue) => {
            field.onChange(newValue ? moment(newValue).format('yyyy-MM-DD') : '');
          }}
          inputFormat="yyyy-MM-dd"
          renderInput={(params) => (
            <TextField
              {...params}
              {...field}
              fullWidth
              error={!!error}
              helperText={error ? error?.message : helperText}
            />
          )}
          {...other}
        />
      )}
    />
  );
}
